import axios from 'axios/index';

const urlProducts = window.location.origin+'/api/products';
const urlStates = window.location.origin+'/api/states';
const urlLanguages = window.location.origin+'/api/languages';
const urlFacilityTypes = window.location.origin+'/api/facilityTypes';
const urlZip = window.location.origin+'/api/getnearZipCodes';
const urlZipState = window.location.origin+'/api/getStateForZipCode';
const urlProvSpecs = window.location.origin+'/api/provspecialities';
const urlHospSpecs = window.location.origin+'/api/hospspecialities';
const urlProvGrpSpecs = window.location.origin+'/api/provgrpspecialities';
const urlHospGrpSpecs = window.location.origin+'/api/hospgrpspecialities';
const urlSearch = window.location.origin+'/api/searchprov';
const downloadFileUrl = window.location.origin+'/api/downloadDirectoryFile';
const urlCounty = window.location.origin+'/api/county';
const urlReportConfig = window.location.origin+'/api/getProviderReportConfig';
const urlReportContent = window.location.origin+'/api/getProviderReportContent';
class ProviderSearchService {
    // get Medicare Lookups
    static getProducts() {
        return new Promise((resolve, reject) => {
            try {
                axios
                    .get(urlProducts)
                    .then(response => (
                        resolve(
                            response.data.map(lookup => ({
                                ...lookup
                            }))
                        )))
            } catch (err) {
                reject(err);
            }
        })
    }
    static getStates() {
        return new Promise((resolve, reject) => {
            try {
                axios
                    .get(urlStates)
                    .then(response => (
                        resolve(
                            response.data.map(lookup => ({
                                ...lookup
                            }))
                        )))
            } catch (err) {
                reject(err);
            }
        })
    }
    static getCounties() {
        return new Promise((resolve, reject) => {
            try {
                axios
                    .get(urlCounty)
                    .then(response => (
                        resolve(
                            response.data.map(lookup => ({
                                ...lookup
                            }))
                        )))
            } catch (err) {
                reject(err);
            }
        })
    }

    static getNearByZipCodes(origin, miles) {
        console.log("window.location.pathname",window.location.origin);
        var params = { 'origin': origin, 'miles': miles };
        return new Promise((resolve, reject) => {
            try {
                axios
                    .post(urlZip, params)
                    .then(response => (
                        resolve(
                            response.data.map(lookup => ({
                                ...lookup
                            }))
                        )))
            } catch (err) {
                reject(err);
            }
        })
    }

    static getStateForZipCode(zipCode) {
        return new Promise((resolve, reject) => {
            try {
                axios
                    .get(urlZipState+'?where={"ZipCode":"'+zipCode+'"}')
                    .then(response => (
                        resolve(
                            response.data.map(lookup => ({
                                ...lookup
                            }))
                        )))
            } catch (err) {
                reject(err);
            }
        })
    }

    static getReportConfiguration() {
        return new Promise((resolve, reject) => {
            try {
                axios
                    .get(urlReportConfig)
                    .then(response => (
                        resolve(
                            response.data.map(lookup => ({
                                ...lookup
                            }))
                        )))
            } catch (err) {
                reject(err);
            }
        })
    }

    static getLanguages() {
        return new Promise((resolve, reject) => {
            try {
                axios
                    .get(urlLanguages)
                    .then(response => (
                        resolve(
                            response.data.map(lookup => ({
                                ...lookup
                            }))
                        )))
            } catch (err) {
                reject(err);
            }
        })
    }

    static getIPAs() {
        return new Promise((resolve, reject) => {
            try {
                axios
                    .get(urlFacilityTypes)
                    .then(response => (
                        resolve(
                            response.data.map(lookup => ({
                                ...lookup
                            }))
                        )))
            } catch (err) {
                reject(err);
            }
        })
    }

    static getProvSpecialities() {
        return new Promise((resolve, reject) => {
            try {
                axios
                    .get(urlProvSpecs)
                    .then(response => (
                        resolve(
                            response.data.map(lookup => ({
                                ...lookup
                            }))
                        )))
            } catch (err) {
                reject(err);
            }
        })
    }

    static getHospSpecialities() {
        return new Promise((resolve, reject) => {
            try {
                axios
                    .get(urlHospSpecs)
                    .then(response => (
                        resolve(
                            response.data.map(lookup => ({
                                ...lookup
                            }))
                        )))
            } catch (err) {
                reject(err);
            }
        })
    }

    static getProvGrpSpecialities() {
        return new Promise((resolve, reject) => {
            try {
                axios
                    .get(urlProvGrpSpecs)
                    .then(response => (
                        resolve(
                            response.data.map(lookup => ({
                                ...lookup
                            }))
                        )))
            } catch (err) {
                reject(err);
            }
        })
    }

    static getHospGrpSpecialities() {
        return new Promise((resolve, reject) => {
            try {
                axios
                    .get(urlHospGrpSpecs)
                    .then(response => (
                        resolve(
                            response.data.map(lookup => ({
                                ...lookup
                            }))
                        )))
            } catch (err) {
                reject(err);
            }
        })
    }

    static findProvider(params) {
        return new Promise((resolve, reject) => {
            try {
                axios
                    .post(urlSearch,params)
                    .then(response => (
                        resolve(
                            response.data.map(lookup => ({
                                ...lookup
                            }))
                        )))
            } catch (err) {
                reject(err);
            }
        })
    }

    static getReportContent(repKey) {
        return new Promise((resolve, reject) => {
            try {
                axios
                    .get(urlReportContent+'?where={"ProviderReportConfigurationKey":'+repKey+'}')
                    .then(response => (
                        resolve(
                            response.data.map(lookup => ({
                                ...lookup
                            }))
                        )))
            } catch (err) {
                reject(err);
            }
        })
    }
    static getDirectoryFile() {
        return new Promise((resolve, reject) => {
            try {
                axios
                    .get(downloadFileUrl)
                    .then(response => (
                        resolve(
                            response.data.map(lookup => ({
                                ...lookup
                            }))
                        )))
            } catch (err) {
                reject(err);
            }
        })
    }
}


    export default ProviderSearchService;
